import { formatDateTime } from '@juvare/common-web-ui/utils';
import { parseISO } from 'date-fns';
import React from 'react';
import { AlertNotificationContentHeader } from '../../../../../components/AlertNotificationContentHeader';
import { useAlertUiTranslation } from '../../../../../hooks';
import { InboxArchivedNotificationActions } from './InboxArchivedNotificationActions';
import { InboxNotificationActions } from './InboxNotificationActions';
export const InboxNotificationHeader = ({ data, onRefresh, onReload, onCloseDialog }) => {
    var _a, _b, _c;
    const { t } = useAlertUiTranslation();
    const InboxActions = () => {
        if (!data) {
            return null;
        }
        const handleReload = (clearActiveNotification) => {
            if (!clearActiveNotification) {
                onRefresh();
            }
            onReload(clearActiveNotification);
        };
        const Actions = (data === null || data === void 0 ? void 0 : data.archived) ? InboxArchivedNotificationActions : InboxNotificationActions;
        return React.createElement(Actions, { notification: data, onReload: handleReload, onCloseDialog: onCloseDialog });
    };
    const dateTimeText = data ? t('common.receivedDate', { date: formatDateTime(parseISO(data.received)) }) : '';
    let phinBadge = '';
    if ((_a = data === null || data === void 0 ? void 0 : data.additionalData) === null || _a === void 0 ? void 0 : _a.phinCommunicationSensitive) {
        if (data.additionalData.phinCommunicationSensitive === 'true') {
            phinBadge = t('phin.common.phinSensitive');
        }
        else {
            phinBadge = t('phin.common.phinNotSensitive');
        }
    }
    return (React.createElement(AlertNotificationContentHeader, { actionsComponent: React.createElement(InboxActions, null), phinBadgeLabel: phinBadge, dateTimeText: dateTimeText, title: data === null || data === void 0 ? void 0 : data.subject, notificationMessageType: (_b = data === null || data === void 0 ? void 0 : data.labels) === null || _b === void 0 ? void 0 : _b[0], sender: (_c = data === null || data === void 0 ? void 0 : data.sender) === null || _c === void 0 ? void 0 : _c.displayName, iconColor: 'blue' }));
};
